import * as React from 'react';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid2';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import Image from 'mui-image';

import PageContainer from './PageContainer';

import coverImage from './images/yhteystiedot.jpg';
import imageKierreportaat from './images/kierreportaat.jpeg';


function PageYhteystiedot() {
    let gridSizes = {
		xs: 12,
        lg: 4
	};
    const accesibilityInfo = (
        <Box>
            <Typography sx={{mb:2, mt:4}} variant='h5'>Esteettömyystiedote</Typography>
            <Typography sx={{mb:2}}>Huomioithan, että kahvilamme sijaitsee rakennuksessa, jossa ei ole hissiä. Asiakastilamme ovat yläkerrassa, jonne kuljetaan kierreportaita pitkin. Tästä syystä kahvilamme ei valitettavasti ole esteetön liikuntarajoitteisille asiakkaille.</Typography>
            <Typography sx={{mb:2}}>Haluamme kuitenkin tarjota kaikille mahdollisimman miellyttävän kokemuksen. Jos sinulla on kysyttävää saavutettavuudesta tai tarvitset apua, otathan meihin rohkeasti yhteyttä!</Typography>
            <Image sx={{pb:"1rem", display:'block', maxWidth: 500}} src={imageKierreportaat}/>
        </Box>
        );
	return (
	<PageContainer header='Sijainti ja Yhteystiedot' header_variant='h3' header_image={coverImage} header_image_position={45}>
        <Grid container spacing={2} sx={{textAlign:'center'}}>
            <Grid size={gridSizes}>
                <Typography sx={{mb:2}} variant='h5'>Sijainti</Typography>
                <iframe title='Google Maps Location' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d686.1431600309215!2d22.25558076972799!3d60.44361475998827!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x468c7765c74f2e6d%3A0x18552546e6959f61!2sKissakahvila%20Mirri!5e1!3m2!1sen!2sfi!4v1736873887381!5m2!1sen!2sfi" height="300" style={{border:0, borderRadius:2}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                <Typography sx={{mb:2}}>Martinkatu 1, 20810 Turku</Typography>
                <Box sx={{display:{xs:"none", lg:"block"}}}>{accesibilityInfo}</Box>
            </Grid>
            <Grid size={gridSizes}>
                <Typography sx={{mb:2}} variant='h5'>Aukiolo</Typography>
                <Typography sx={{mb:2}}>
  Ma-Pe 13:00-18:00<br />
  La 12:00-19:00<br />
  Su 13:00-17:00
</Typography>
                <Typography sx={{mb:2}}><Link href="https://maps.app.goo.gl/qFnekkdP1jwTeeAD8" target="_blank">Poikkeusaukiolo päivitetään google maps:iin</Link></Typography>
                <Typography sx={{mb:2}}>Ei sisäänpääsymaksua.</Typography>
                <Typography sx={{mb:2}}>Emme lähtökohtaisesti ota pöytävarauksia, sillä haluamme säilyttää kahvilan spontaanina ja helposti lähestyttävänä paikkana. Tavoitteemme on luoda tila, johon voi poiketa hetken mielijohteesta nauttimaan kissojen seurasta ja kahvilan tunnelmasta – ilman varauksen tarvetta.</Typography>
                <Typography sx={{mb:2}}>Kahvilamme on suunnattu ensisijaisesti aikuisille ja rauhalliseen yhdessäoloon kissojen kanssa. Lapsiasiakkaat ovat lämpimästi tervetulleita vanhempiensa seurassa. Pyydämme kuitenkin vanhempia valvomaan lapsiaan huolellisesti ja huolehtimaan, että kahvilan sääntöjä noudatetaan. Näin varmistamme kaikkien turvallisuuden ja viihtyvyyden – erityisesti kissojemme.</Typography>
                <Typography sx={{mb:2}}>Kiitos ymmärryksestä ja yhteistyöstä!</Typography>
                <Box sx={{display:{xs:"block", lg:"none"}}}>{accesibilityInfo}</Box>
            </Grid>
            <Grid size={gridSizes}>
                <Typography sx={{mb:2}} variant='h5'>Yhteystiedot</Typography>
                <Box sx={{display:'flex', flexDirection:'column', }}>
                    <Typography sx={{mt:2}}>Sähköposti</Typography>
                    <Link href="mailto:kissakahvila.mirri@gmail.com">kissakahvila.mirri@gmail.com</Link>
                    <Typography>Valitettavasti emme palkkaa kesätyöntekijöitä.</Typography>
                    <Typography>Toistaiseksi pystymme tarjoamaan yhden paikan kerrallaan harjoittelijoille tai työkokeilijoille.</Typography>
                    <Typography sx={{mt:2}}>Instagram</Typography>
                    <Link href="https://www.instagram.com/kissakahvila.mirri/" target="_blank">KISSAKAHVILA.MIRRI</Link>
                    <Typography sx={{mt:2}}>Facebook</Typography>
                    <Link href="https://www.facebook.com/people/Kissakahvila-Mirri/61564446741107/" target="_blank">Kissakahvila Mirri</Link>
                </Box>
            </Grid>
        </Grid>
	</PageContainer>
    );
}

export default PageYhteystiedot;